import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll'

import './Banner.css';

const banner = props => {

    return (
        <div className="banner">
            <h1>{props.title}</h1>
            <div className="banner_subtitle">
                Benessere, Salute e Bellezza sono gli elementi che riteniamo essenziali per armonizzare corpo, mente e spirito
            </div>
            <AnchorLink href="#servizi">Scopri di piu'...</AnchorLink>
        </div>
    );
};

export default banner;